import pages from './pages/en-US/pages';
import industries from './industry/en-US';

export default {
  ...pages,
  ...industries,
  "app.massPayment.footer.copyright": "TRAVEL TAO LIMITED",
  "menu.esign": "Online signing",
  "menu.esign.esign-index": "Online signing",
  "menu.welcome": "Welcome to use",
  "menu.home": "Home",
  "menu.layout": "Layout",
  "menu.company-management": "Company Management",
  "menu.company-management.info": "Company Information",
  "menu.company-management.add": "Add Company",
  "menu.company-management.base": "Add Company",
  "menu.company-management.nda": "Sign the NDA",
  "menu.company-management.due-diligence-form": "Due Diligence Form",
  "menu.company-management.aml-ctf-scp-questionnaire": "AML/CTF/Sanctions Questionnaire",
  "menu.company-management.contract-management": "Contract Management",
  "xch_00019": "Status",
  "xch_00030": "Name",
  "xch_00031": "Gender",
  "xch_00032": "Country",
  "xch_00046": "Identification Details",
  "xch_00050": "OK",
  "xch_00052": "Save",
  "xch_00086": "Cancel",
  "xch_00112": "Confirm",
  "xch_00115": "Your balance is insufficient",
  "xch_00116": "Please deposit funds to your wallet first",
  "xch_00135": "You have a batch transfer pending payment, please continue to complete the payment or cancel it.",
  "xch_00136": "You have a batch transfer under the transfer processing state, please wait patiently for the batch transfer to complete before uploading a new batch.",
  "xch_00150": "Export",
  "xch_00156": "Sorry, the number of your transfers exceeds the maximum of {0} we support. Please delete some transfer(s) and upload again.",
  "xch_00157": "Sorry, we did not read any transfer data in the file you uploaded. Please make sure your uploaded file is correct and upload it again.",
  "xch_00160": "Completed",
  "xch_00161": "Failed",
  "xch_00162": "Cancelled",
  "xch_00172": "Basic info",
  "xch_00174": "Type",
  "xch_00175": "Issue Country",
  "xch_00178": "Address",
  "xch_00180": "City",
  "xch_00191": "State / Province",
  "xch_00193": "Nationality",
  "xch_00194": "Occupation",
  "xch_00208": "Temporarily unable to pay",
  "xch_00209": "Payment failed due to failure to perform batch transfer in cross-currency transaction mode (transfer availability time is Monday to Friday 9:30-16:00, UTC+08:00 on working days). Please try to perform a payment to this batch transfer within the settlement time or use the same currency transaction mode (transfer availability time is 7x24 hr). If you have any questions, please contact us.",
  "xch_00248": "Export {0} items",
  "xch_00249": "Export {0} item",
  "xch_00250": "Template",
  "xch_00251": "Custom columns",
  "xch_00252": "Available Column",
  "xch_00253": "Display Column",
  "xch_00255": "The upload failed due to network fluctuations, please upload again.",
  "xch_00256": "Log out",
  "xch_00257": "Authorization failed. Please re-login. ",
  "xch_00258": "Re-Login",
  "xch_00302": "Exchange",
  "xch_00308": "Low Cost Mode",
  "xch_00309": "Quick Mode",
  "xch_00332": "Support low-cost exchange fund",
  "xch_00333": "Support quick exchange fund",
  "xch_00353": "Self",
  "xch_00354": "Parent",
  "xch_00355": "Spouse",
  "xch_00356": "Children",
  "xch_00357": "Sibling",
  "xch_00362": "Male",
  "xch_00371": "Streets",
  "xch_00373": "Postcode",
  "xch_00376": "The exchange rate has changed",
  "xch_00377": "Because of the international foreign exchange market fluctuations in real-time, the exchange rate has changed. Please reconfirm the exchange rate quotation.",
  "xch_00379": "Issuing Date",
  "xch_00387": "We have fully upgraded to the same-currency (CNY) transaction mode, which supports 7×24 hour instant transfer. Please exchange the foreign currency to the CNY wallet before batch transfer. If you have any questions, you can contact our customer success manager.",
  "xch_00388": "Got it",
  "xch_00404": "Exchange is not available at the moment",
  "xch_00405": "Exchange is available on {0}, please try again at this time.",
  "xch_00429": "Rejected",
  "xch_00430": "Change Password",
  "xch_00433": "Awaiting Transfer",
  "xch_00434": "Pending",
  "xch_00435": "Pending Material",
  "xch_00438": "According to the anti-money laundering requirements of cooperative banks, in order to ensure the continuous use of our servicesPlease submit the proof of the relationship between the payee",
  "xch_00439": "and the payer",
  "xch_00440": "within 48 hours.",
  "xch_00442": "The payee is the payer's",
  "xch_00443": "Append Material",
  "xch_00444": "Please select the certificate type to be authenticated.",
  "xch_00445": "Payer's certificate",
  "xch_00446": "Marriage Certificate",
  "xch_00447": "Kinship Commitment Letter",
  "xch_00448": "Household Register Book",
  "xch_00449": "Maintenance Notary Certificate",
  "xch_00450": "Birth Certificate",
  "xch_00451": "Employment Contract",
  "xch_00452": "Income Statement",
  "xch_00453": "Incumbency Certification",
  "xch_00454": "Salary/wage Statement",
  "xch_00455": "Tax Certificate",
  "xch_00456": "Sibling",
  "xch_00457": "Grandchildren",
  "xch_00465": "Please Upload",
  "xch_00466": "Template",
  "xch_00467": "Examples are as follows",
  "xch_00472": "The relationship cannot be other people. If you need supplementary materials, please contact the account manager.",
  "xch_00473": "Online signature",
  "xch_00474": "Please sign before submitting.",
  "xch_00475": "Online signing",
  "xch_00479": "Refresh Kinship Commitment Letter",
  "xch_00480": "Refresh",
  "xch_00481": "PAN-ASIA Mode",
  "xch_00482": "Welcome to use",
  "xch_00499": "Support PAN-ASIA Exchange",
  "xch_00510": "If you know your payee’s bank details, you can transfer money directly to their bank accounts.",
  "xch_00511": "Collection information of payees：",
  "xch_00512": "Payee Full Name (Chinese)",
  "xch_00513": "Payee Gender",
  "xch_00514": "Payee Nationality",
  "xch_00515": "Payee Occupation",
  "xch_00516": "Payee Postcode ",
  "xch_00517": "Payee Province",
  "xch_00518": "Payee City ",
  "xch_00519": "Payee Prefecture or District",
  "xch_00520": "Payee Addressline1 ",
  "xch_00521": "Payee Phone Number",
  "xch_00522": "Payee ID Card No",
  "xch_00523": "Chinese ID Start Date",
  "xch_00524": "Chinese ID Expire Date",
  "xch_00525": "Payee Bank Card No",
  "xch_00526": "If you just know your payee’s bank little details, you can transfer money directly to their bank accounts.",
  "xch_00527": "Payee Full Name (Chinese)",
  "xch_00535": "Classic Mode",
  "xch_00536": "Xpress Mode",
  "xch_00551": "The transaction is faster, but the exchange rate is not optimal.",
  "xch_00552": "The exchange rate is the best, but the transaction is not the fastest.",
  "xch_00553": "The fastest transaction also has a better exchange rate.",
  "xch_00563": "Interpretation of trading mode",
  "xch_00568": "Email",
  "xch_00574": "Please Input {0}",
  "xch_00581": "Success",
  "xch_00582": "fail",
  "xch_00618": "Completed",
  "xch_00619": "Allocating",
  "xch_00620": "Support classic mode batch",
  "xch_00621": "Support xpress mode batch",
  "xch_00623": "Transferring",
  "xch_00647": "lastNameEn",
  "xch_00648": "Last Name (Pinyin)",
  "xch_00649": "First Name",
  "xch_00650": "First Name (Pinyin)",
  "xch_00651": "DOB",
  "xch_00652": "IdNumber",
  "xch_00653": "Expiration Date",
  "xch_00654": "Female",
  "xch_00655": "back",
  "xch_00656": "front",
  "xch_00657": "side",
  "xch_00665": "This field is required",
  "xch_00669": "PreView",
  "xch_00674": "Select the supporting materials to submit",
  "xch_00693": "Please check whether it is filled in completely",
  "xch_00736": "Append Material",
  "xch_00769": "DepositPayment",
  "xch_00770": "FullPayment",
  "xch_00771": "FinalPayment",
  "xch_00772": "Other",
  "xch_00779": "Overrule",
  "xch_00780": "Shop Website",
  "xch_00800": "According to the anti-money laundering requirements of the cooperative bank, in order to ensure the continuous use of our services, please submit the image of the ID card of the payee {0} within 48 hours.",
  "xch_00801": "Upload Resident ID Card of PRC",
  "xch_00802": "Profile page ",
  "xch_00803": "National emblem side ",
  "xch_00804": "Attention: please do not use card case or wite-out to cover the documents",
  "xch_00805": "Wrong direction",
  "xch_00806": "Incomplete Shooting",
  "xch_00807": "Reflecting strong",
  "xch_00808": "Ambiguous",
  "xch_00810": "Proof of identity",
  "xch_00811": "Proof of transaction",
  "xch_00813": "Due to changes in policies, relevant orders need to be fulfilled with identity data to complete.",
  "xch_00814": "According to the domestic bank and regulatory requirements, you need to provide transaction proof in the background to ensure the safety of your remittance.",
  "xch_00823": "Failure to get information",
  "xch_00830": "Jurisdiction of Incorporation\n",
  "xch_00831": "Name of the Company",
  "xch_00832": "Company Website",
  "xch_00833": "Company Sector",
  "xch_00834": "Basic information",
  "xch_00835": "Certificate of Incorporation",
  "xch_00836": "Shareholder Structure",
  "xch_00837": "UBOs/Directors' Information Document",
  "xch_00838": "UBO Identity Document",
  "xch_00839": "Licensing Documentation",
  "xch_00843": "NDA Document",
  "xch_00844": "Previous step",
  "xch_00846": "Fill in Company Info",
  "xch_00850": "Company Details",
  "xch_00854": "Sign",
  "xch_00858": "Questionnaire",
  "xch_00889": "Submit",
  "xch_00890": "Successful submission",
  "xch_00893": "Save successfully",
  "xch_00895": "Resubmit",
  "xch_00934": "Current Progress",
  "xch_00935": "Bank/Digital Bank",
  "xch_00936": "Payment Company",
  "xch_00937": "Remittance Company",
  "xch_00938": "Other Institution（please specify）",
  "xch_00940": "Please carefully read and {0} the relevant information, and {1} your personal information at the end of the document.",
  "xch_00941": "fill in",
  "xch_00943": "Completed, Next Step",
  "xch_00944": "Transferred",
  "xch_00945": "Refunded",
  "xch_00949": "Business Registration Certificate",
  "xch_00950": "Annual Return of the Company",
  "xch_00951": "Articles of Association",
  "xch_00952": "Office Photos",
  "xch_00953": "AML/CTF Policy",
  "xch_00954": "Risk Assessment Report",
  "xch_00955": "AML/Compliance Officer's Resume",
  "xch_00956": "Board Resolution",
  "xch_00957": "Company Documents",
  "xch_00958": "UBOs/Directors' Documents",
  "xch_00959": "Compliance Documents",
  "xch_00961": "Document review failed, please resubmit.",
  "xch_00962": "Thank you for choosing the PAN-ASIA Cross-border Payment System. In accordance with compliance requirements for cooperation between licensed financial institutions, please follow the steps below to provide more information, allowing us to quickly understand your company's basic situation.",
  "xch_00963": "Please enter the company name",
  "xch_00964": "In accordance with financial institution compliance requirements, we need to collect some detailed information about your company to assess its business condition and qualifications, ensuring compliance with financial regulations. All information will be kept strictly confidential and securely stored.",
  "xch_00966": "Submission Successful!",
  "xch_00967": "Please click to jump to the pending content or materials to check and complete. If you encounter any problems during the process, please contact your account manager at any time.",
  "xch_00968": "Welcome Back",
  "xch_00969": "You have {0} steps remaining to complete",
  "xch_00970": "Please navigate to the incomplete steps to continue filling in or uploading",
  "xch_00971": "Continue Filling/Uploading",
  "xch_00972": "We recommend you prepare the corresponding documents according to the following checklist. This will significantly save your time.",
  "xch_00979": "Click to fill in online signatory info",
  "xch_00980": "Other authorized persons can be invited to sign",
  "xch_00981": "Save failed, the content you edited is no longer the latest, please check the content and save again.",
  "xch_00984": "Save and Submit for Pre-Review",
  "xch_00985": "Required fields are missing",
  "xch_00986": "Must be signed by a director or representative",
  "xch_00987": "Valid ID proof and valid address proof of all directors and UBOs. UBO refers to the natural person who ultimately owns or controls the company by holding 25% or more than 25% of its shares or voting rights.",
  "xch_00988": "If there is no ultimate beneficiary owning more than 25% of the shares, provide the passport photo and valid address proof of the individual with ultimate control of the company",
  "xch_00989": "Financial payment license or business permit issued by the local regulatory authority",
  "xch_00990": "Please provide the latest version",
  "xch_00991": "If available, please provide the latest version",
  "xch_00992": "You can use the company's resolution, or {0} for filling and confirmation.",
  "xch_00993": "I am ready, Apply Now",
  "xch_00994": "Download Template",
  "xch_00995": "Welcome.",
  "xch_00996": "Congratulations! You have successfully registered and logged into the PAN-ASIA Cross-border Payment System. Before we start, in compliance with international requirements for licensed financial institutions, you shall need to complete our customer onboarding procedure in the following steps.",
  "xch_00997": "Each step will clearly indicate where uploads or entries are required.",
  "xch_00998": "Please prepare the following digital documents in formats such as JPG, PDF, DOC, etc.",
  "xch_00999": "Content was auto-saved to the cloud at {0}",
  "xch_01000": "Fill Out Questionnaire",
  "xch_01001": "Your completion rate is below standard. Are you sure you want to submit? A higher completion rate increases approval success!",
  "xch_01002": "Confirm Submission",
  "xch_01003": "If any",
  "xch_01004": "On-site office photos containing the company name or brand name",
  "xch_01005": "Shareholding structure chart (must be signed by a director or representative), identity documents of the ultimate beneficiary (passport photo and valid address proof of the ultimate beneficiary owning more than 25% of the shares), and identity information of the actual controller (if there is no ultimate beneficiary owning more than 25% of the shares, provide the passport photo and valid address proof of the individual with ultimate control of the company)",
  "xch_01007": "If you hold 25% or more shares, please provide the latest version",
  "xch_01008": "AML/CTF/Sanctions Questionnaire",
  "xch_01009": "Due Diligence Form",
  "xch_01010": "Must be filled in",
  "xch_01011": "We recommend that you prepare the corresponding documents according to the following checklist before starting. This will significantly save your time. If you encounter any problems during the process, please contact your account manager at any time.",
  "xch_01012": "Review Progress",
  "xch_01013": "Review Completed",
  "xch_01014": "Under Review",
  "xch_01015": "Rejected",
  "xch_01016": "Invitation failed, please re-invite or contact your dedicated account manager.",
  "xch_01018": "Please enter your name!",
  "xch_01019": "Please enter your email!",
  "xch_01022": "Fill Now",
  "xch_01023": "You have filled and signed",
  "xch_01024": "Awaiting Signature Completion",
  "xch_01025": "Please Fill Signatory Info",
  "xch_01027": "According to financial institution compliance requirements, we need to understand your company's practices and detailed information regarding business compliance and anti-money laundering/anti-terrorism financing through a questionnaire. This ensures compliance with financial regulations and is a necessary condition for us to provide services to your company. All information will be kept strictly confidential and securely stored.",
  "xch_01028": "Shareholding structure chart (must be signed by a director or representative)",
  "xch_01029": "Ultimate beneficiary identification documents (passport photo and valid address proof of the ultimate beneficiary owning more than 25% of the shares)",
  "xch_01030": "Actual controller identification information (if there is no ultimate beneficiary owning more than 25% of the company's shares, provide the passport photo and valid address proof of the individual with ultimate control of the company)",
  "xch_01031": "License proof (financial payment license or business license issued by local regulatory authorities)",
  "xch_01032": "AML/CTF policy (please provide the latest version)",
  "xch_01033": "Independent third-party risk assessment report (if available, please provide the latest version)",
  "xch_01034": "Resume of the AML officer/compliance officer",
  "xch_01035": "Board resolution for account opening",
  "xch_01036": "AML/CTF/Sanctions Questionnaire (to be filled)",
  "xch_01037": "Due Diligence Form (to be filled)",
  "xch_01038": "Please carefully read and {0} the relevant information. After completing the form, please {1} it for preliminary review. Once the preliminary review is passed, an authorized person will need to sign online.",
  "xch_01039": "Save and Submit for Review",
  "xch_01040": "An error occurred, please refresh and try again.",
  "xch_01043": "Questionnaire attachment",
  "xch_01044": "Upload supporting documents to help us better understand your business (e.g., fund flow of your business)",
  "xch_01045": "Questionnaire pending your completion and submission for preliminary review",
  "xch_01046": "Your questionnaire is under preliminary review",
  "xch_01047": "Preliminary review of the questionnaire completed, awaiting your signature request",
  "xch_01048": "Sign Now",
  "xch_01049": "Top",
  "xch_01050": "Bottom",
  "xch_01051": "Preliminary review not approved, reason: {0}",
  "xch_01052": "Please upload files in image formats (JPEG, PNG, etc.) or PDF format.",
  "xch_01087": "Nature of Business",
  "xch_01088": "Please enter the industry detail name",
  "xch_01090": "CNY Mode",
  "xch_01091": "Cross Mode",
  "xch_01092": "Original Mode",
  "xch_01093": "Skip for Now",
  "xch_01094": "Missing Document Information",
  "xch_01110": "Submission Complete",
  "xch_01186": "Wallet Mode",
  "xch_01187": "If you want to receive payment amount by  Alipay/Wechat",
  "xch_01188": "Payee Name (PinYin)",
  "xch_01189": "Payee ID Card No",
  "xch_01190": "Payee Alipay/Wechat ID",
  "xch_01218": "HK Visa Identity Doc",
  "xch_01219": "Driver’s License",
  "xch_01220": "Exemption",
  "xch_01221": "Mainland Travel Permit (HK/Macao)",
  "xch_01222": "Health Insurance Card",
  "xch_01223": "ID Card",
  "xch_01224": "HK Non-Permanent ID",
  "xch_01225": "Personal Notice Card",
  "xch_01226": "Mainland Entry Permit (Single)",
  "xch_01227": "Temp Document",
  "xch_01228": "Passport",
  "xch_01229": "PersonCard",
  "xch_01230": "Residence Permit",
  "xch_01231": "Residence Card",
  "xch_01232": "Resident Cert",
  "xch_01233": "Selfie",
  "xch_01234": "HK/Macao to Mainland Permit",
  "xch_01235": "Visa",
  "xch_01247": "Click to View",
  "xch_01290": "Status Explanation",
  "xch_01291": "Description",
  "xch_01292": "Pending for the merchant to complete the upload certification materials",
  "xch_01293": "Pending for transfer. Only in this status can be transferred",
  "xch_01294": "Due to incomplete materials, the order needs to be resubmitted",
  "xch_01295": "Submitted successfully, processing in xCurency Hubs",
  "xch_01296": "Remittance in progress",
  "xch_01297": "The remittance instruction has been executed, but the remittance being credited to the user's account is subject to the bank's final processing.",
  "xch_01298": "Remittance is complete. User has received payment",
  "xch_01299": "Transfer fail, the Cross-Currency Transaction Mode will refund",
  "xch_01300": "Sender's compliance information is not approved or for risk control reasons, etc.",
  "xch_01301": "Payment cancelled",
  "xch_01302": "Payment Refunded",
  "xch_01327": "The currency exchange amount exceeds the limit. Please contact your dedicated account manager!",
  "xch_01339": "Personal Salary / Family Support",
  "xch_01340": "Enterprise Payroll",
  "xch_01341": "Goods Trade",
  "xch_01342": "Service Trade",
  "xch_01343": "Overseas Tuition/Education Fee Payment",
  "xch_01344": "Others",
  "xch_01345": "Select Product",
  "xch_01346": "What type of PAN-ASIA product do you plan to use?",
  "xch_01347": "Please select the type(s) of PAN-ASIA product you intend to use to help us provide a more personalized service (Multiple selections are allowed.)",
  "xch_01348": "Do you hold a financial license?",
  "xch_01351": "Business Document",
  "xch_01352": "Personal Salary – Payslip / Tax Slip",
  "xch_01353": "Submit Sample Supporting Document * 1",
  "xch_01354": "Goods Trade – Proforma Invoice (PI)",
  "xch_01355": "Goods Trade – Logistics Document",
  "xch_01356": "Service Trade – Relevant Contract",
  "xch_01357": "Enterprise Payroll– Employee Contract",
  "xch_01358": "Enterprise Payroll – Employee List",
  "xch_01359": "Submit Any 2 Employment Contracts",
  "xch_01360": "Personal Family Support – Relationship Proof Document",
  "xch_01361": "Countries of Business Operation",
  "xch_01363": "Thank you for registering! Our team will complete the backend review as soon as possible, and a specialist will get in touch with you. Once approved, you will have full access. We appreciate your patience. If you have any questions, feel free to contact us at any time.",
  "xch_01460": 'Company Registration Number',
  "xch_01515": "Spot Exchange Buy (TT Buy)",
  "xch_01516": "Cash Buy Rate",
  "xch_01517": "Spot Exchange Sell (TT Sell)",
  "xch_01518": "Cash Sell Rate",
  "xch_01519": "Central Parity Rate",
  "xch_01588": " Withdrawal failed",
  "xch_01589": "Withdrawal wallet not found, please contact your account manager",
  "xch_01609": "Bank Transfer",
  "xch_01610": "Counter Cash/Card Transaction",
  "xch_01611": "PayNow",
  "xch_01612": "NETS",
  "xch_01613": "UBO full name (as on ID)",
  "xch_01614": "Date of birth",
  "xch_01615": "Provide the beneficial owner details that match the uploaded UBO information document.",
  "xch_01616": "Male",
  "xch_01617": "Female",
  "xch_01618": "Ultimate beneficial owner",
  "xch_01619": "Identity details",
  "xch_01620": "Please select",
  "xch_01621": "Select date",
  "xch_01622": "Please enter",
  "xch_01623": "Equity stake (%)",
  "xch_01624": "Enter 1–100 for percentage (e.g. 25 for 25%). Stored as a decimal from 0 to 1.",
  "xch_01625": "Enter a number between 1 and 100",
  "xch_01626": "Add beneficial owner",
  "xch_01627": "Remove this entry",
  "xch_01628": "Beneficial owner {0}",
  "xch_01629": "Total equity across all beneficial owners cannot exceed 100%"
}